import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetHistoryList = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_HISTORY
            });
            if (data.status === 'success') {
                const events = [...getState().historyMobile.list.data];
                for (let i = 0; i < data.data.length; i = i + 2) {
                    const event_win = data.data[i];
                    const event_bet = data.data[i + 1];
                    const temp = {
                        date_event: event_win.date_event,
                        game: event_win.name,
                        amount_win: event_win.amount,
                        amount_bet: event_bet.amount,
                        login: event_win.login
                    }
                    events.push(temp)
                }
                dispatch(Action.SetGetHistoryListAction({
                    data: events.flat(1),
                    countPage: data.countPage
                }));
                dispatch(Action.SetLoadingAction(false))
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetHistoryList as SetGetHistoryList
}